import request from '@/axios/axios'
// 登录
export function getWebConfig(data) {
	return request.request({
		url: '/config/getWebConfig',
		method: 'post',
		data
	})
}

// 登录
export function login(data) {
	return request.request({
		url: '/user/login',
		method: 'post',
		data
	})
}

// 登出
export function logout(data) {
	return request.request({
		url: '/user/logout',
		method: 'post',
		data
	})
}

//获取专业数据
export function getMajors(data) {
	return request.request({
		url: '/index/getMajors',
		method: 'post',
		data
	})
}

//获取首页数据
export function getIndex(data) {
	return request.request({
		url: '/index/getIndex',
		method: 'post',
		data
	})
}


//获取个人信息
export function getUserInfo(data) {
	return request.request({
		url: '/user/getUserInfo',
		method: 'post',
		data
	})
}

//点击首页弹窗 退出弹窗 点击不再打开时调用 统计点击次数
export function clickIndexAdvertisementPopup(data) {
	return request.request({
		url: '/advertisementPopup/clickIndexAdvertisementPopup',
		method: 'post',
		data
	})
}

//获取首页弹窗广告(relateBizType 0H5 1打包课 2点播 3直播 4每日任务)
export function getIndexAdvertisementPopup(data) {
	return request.request({
		url: '/advertisementPopup/getIndexAdvertisementPopup',
		method: 'post',
		data
	})
}


// WEBPACK FOOTER //
// ./src/api/home.js